import DefaultUpdater from "../../../common/DefaultUpdater";
import classes from "./DayOneAttyStatus.module.css";

export default function FastHelpCheckbox({additional}) {
    return <div className={classes.fastHelpEnd}>
        <DefaultUpdater
            type={'checkbox'}
            value={additional?.fast_help}
            label={'Fast Help'}
            identifier={{type: 'case_additional', field: 'fast_help', type_id: null, folder: 'additional', permissionType: 'case_attorney'}}
            extraOptions={{direction: 'reverse'}}
        />
    </div>
}
